
import React from 'react';
import { InfoTwoTone as InfoIcon } from '@mui/icons-material';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { classes, StyledHtmlTooltip } from './TooltipValueViewer.styles';



const TooltipValueViewer = ({ cell }: { cell: ICell }) => (
  <StyledHtmlTooltip title={cell.defaultTooltip ?? ''} placement="top" arrow>
    <span className="value-viewer">
      <span className="text-cell">{cell.value}</span>
      <InfoIcon className={classes.icon} />
    </span>
  </StyledHtmlTooltip>
);

export default TooltipValueViewer;
